<template>
<div id="electric_consumption" :class=div_classes >

<h3>

{{ $t('commute.title.electricconsumption.range') }} 

</h3>

<SelectRange 
:min="charge_distance_min"
classes="slider_blue"
:max="charge_distance_max"
:default_value=display_charge_distance
v-model=display_charge_distance
>
<div slot="gauge" >
{{ distanceGauge }}
</div>       
</SelectRange>                   

<h3>
{{ $t('commute.title.electricconsumption.battery_capacity') }} 

 <small>
<a target="_blank" 
:href="$t('commute.electricconsumption.helplink')" >
{{ $t('commute.link.help') }} 
</a>
</small></h3>
<SelectRange 
:min="charge_capacity_min"
:max="charge_capacity_max"
:step="charge_capacity_step"
classes="slider_blue"
:default_value=display_charge_capacity
v-model=display_charge_capacity
>

<div slot="gauge" >
{{ capacityGauge }}
</div> 
</SelectRange>

</div>
</template>

<script>

import conversions from '../conversions.js'
import SelectRange from './SelectRange.vue'

export default {
  name: 'VehicleElectricConsumption',
  components: {
    SelectRange
  },
  data: function(){
    return {
    }
  },
  props: {
    charge_distance : {
        type : Number,
        default : NaN
    },
    charge_capacity : {
        type : Number,
        default : NaN
    },
    charge_distance_min : {
        type : Number,
        default : 20
    },
    charge_distance_max : {
        type : Number,
        default : 500
    },
    charge_capacity_min : {
        type : Number,
        default : 10
    },
    charge_capacity_max : {
        type : Number,
        default : 150
    }, 
    defaults : Object,
    div_classes : String,
    name : String,
  },
   computed: {
        charge_capacity_step : function(){
            if(this.charge_capacity_min < 5){
                return 0.1
            }
            return 5
        },
        display_charge_capacity : {
            get(){
                return (isNaN(this.charge_capacity) ? this.defaults['charge_capacity'] : this.charge_capacity)
            },set(val){
                this.$emit('charge_capacity', val)
            }
        },
        display_charge_distance : {
            get(){
                return (isNaN(this.charge_distance) ? this.defaults['charge_distance'] : this.charge_distance)
            },set(val){
                this.$emit('charge_distance', val)
            }
        },
        distanceGauge : function () {
            return conversions.formatDistance(this.display_charge_distance, 0)
        },
        capacityGauge : function () {
            if(this.display_charge_capacity < 10){
                return parseInt(this.display_charge_capacity*1000) + " Wh"
            }
            return parseInt(this.display_charge_capacity) + " kWh"
        },
  },
    methods : {

  }
}
</script>

<style>

a, a:visited {
    color: inherit;
}

.slider_blue {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: 25px; /* Specified height */
    outline: none; /* Remove outline */
    
    border-radius: 10px;

    background: rgb(206,219,233); /* Old browsers */
    background: -moz-linear-gradient(left, rgba(206,219,233,1) 0%, rgba(170,197,222,1) 17%, rgba(97,153,199,1) 50%, rgba(65,154,214,1) 59%, rgba(58,139,194,1) 84%, rgba(75,184,240,1) 100%, rgba(38,85,139,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, rgba(206,219,233,1) 0%,rgba(170,197,222,1) 17%,rgba(97,153,199,1) 50%,rgba(65,154,214,1) 59%,rgba(58,139,194,1) 84%,rgba(75,184,240,1) 100%,rgba(38,85,139,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, rgba(206,219,233,1) 0%,rgba(170,197,222,1) 17%,rgba(97,153,199,1) 50%,rgba(65,154,214,1) 59%,rgba(58,139,194,1) 84%,rgba(75,184,240,1) 100%,rgba(38,85,139,1) 100%);
    
    border: 1px solid #fff;

}

div#electric_consumption {
    max-width: 400px;
}

.slider_blue::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #666; /* Green background */
    cursor: pointer; /* Cursor on hover */
        border-radius: 1em;

}

.slider::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #666; /* Green background */
    cursor: pointer; /* Cursor on hover */
    border-radius: 1em;
}

</style>
